module.exports = __webpack_public_path__ + "img/brand3.aca9df72.png";